module.exports = __webpack_public_path__ + "img/photo-0022.eb910e07.jpg";